import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-result-failed',
  templateUrl: './result-failed.component.html',
  styleUrls: ['./result-failed.component.scss'],
})
export class ResultFailedComponent {}
